import { definePreset, palette } from '@primeuix/themes'
import Aura from '@primeuix/themes/aura'

const nebulaPalette = palette('#9C97C9')
const config = {
  primitive: {
    nebula: nebulaPalette,
  },
  semantic: {
    primary: nebulaPalette,
    colorScheme: {
      light: {
        surface: {
          0: '#ffffff',
          50: '#f8fafc',
          100: '#f1f5f9',
          200: '#e2e8f0',
          300: '#cbd5e1',
          400: '#94a3b8',
          500: '#64748b',
          600: '#475569',
          700: '#334155',
          800: '#1e293b',
          900: '#0f172a',
          950: '#020617',
        },
        purple: {
          0: '#ffffff',
          50: '#f8f2ff',
          100: '#f0e5ff',
          200: '#e0ccff',
          300: '#c9a6ff',
          400: '#ae7dff',
          500: '#9770E5',
          600: '#843ee6',
          700: '#6d2bc2',
          800: '#51208f',
          900: '#36155f',
          950: '#1d0b36',
        },
        red: {
          0: '#ffffff',
          50: '#ffe5ea',
          100: '#ffccd5',
          200: '#ff99ab',
          300: '#ff6680',
          400: '#ff3356',
          500: '#DA002C',
          600: '#b80025',
          700: '#94001e',
          800: '#700016',
          900: '#4d000f',
          950: '#2b0008',
        },
      },
      dark: {
        surface: {
          0: '#ffffff',
          50: '#f6f6f6',
          100: '#d5d5d5',
          200: '#b5b5b5',
          300: '#949494',
          400: '#737373',
          500: '#525252',
          600: '#464646',
          700: '#393939',
          800: '#2d2d2d',
          900: '#212121',
          950: '#151515',
        },
        purpleDark: {
          0: '#08050d',
          50: '#12091f',
          100: '#1d0f33',
          200: '#32185a',
          300: '#4d2487',
          400: '#7036bd',
          500: '#9b5ff5',
          600: '#b985ff',
          700: '#d0aaff',
          800: '#e5ccff',
          900: '#f4eaff',
          950: '#fbf7ff',
        },
        red: {
          0: '#ffffff',
          50: '#ffe5ea',
          100: '#ffccd5',
          200: '#ff99ab',
          300: '#ff6680',
          400: '#ff3356',
          500: '#DA002C',
          600: '#b80025',
          700: '#94001e',
          800: '#700016',
          900: '#4d000f',
          950: '#2b0008',
        },
        text: {
          color: '#f5f5f5',
          hoverColor: '#ffffff',
          mutedColor: '#d4d4d4',
          hoverMutedColor: '#f5f5f5',
        },
        content: {
          background: '#212121',
          hoverBackground: '#2d2d2d',
          borderColor: '#464646',
          color: '#f5f5f5',
          hoverColor: '#ffffff',
        },
        formField: {
          color: '#f5f5f5',
          disabledColor: '#b5b5b5',
          placeholderColor: '#b5b5b5',
        },
      },
    },
  },
  components: {
    datatable: {
      colorScheme: {
        light: {
          row: {
            hoverBackground: '{primary.50}',
            selectedBackground: '{primary.200}',
            selectedColor: '{primary.900}',
          },
        },
        dark: {
          header: {
            background: '#212121',
            color: '#f5f5f5',
            borderColor: '#393939',
          },
          headerCell: {
            background: '#212121',
            hoverBackground: '#2d2d2d',
            color: '#f5f5f5',
            hoverColor: '#ffffff',
            borderColor: '#393939',
          },
          row: {
            background: '#212121',
            hoverBackground: '{primary.900}',
            selectedBackground: '{primary.800}',
            color: '#f5f5f5',
            hoverColor: '#ffffff',
            selectedColor: '{primary.50}',
            stripedBackground: '#262626',
          },
          bodyCell: {
            borderColor: '#393939',
          },
        },
      },
    },
  },
}

const AppTheme = definePreset(Aura, config)

export { AppTheme }
